import { useState } from "react";
import { useAuth } from "../../components/useAuth";
import { useForm } from "react-hook-form";
import "./Announcement.css"; // 共通デザイン
import { useNavigate } from "react-router-dom";

const api_url = "https://api.ope-note.jp/admin/movie_rating.php";

const MovieRating = () => {
  const { token } = useAuth();
  const [searching, setSearching] = useState(false);
  const navigate = useNavigate();
  const [error, setError] = useState(null);
  const {
    register,
    handleSubmit,
    formState: {},
  } = useForm();
//   const csvDownload = async (data) => {
//     setSearching(true);
//     try {
//       const response = await fetch(api_url, {
//         method: "POST",
//         mode: "cors",
//         credentials: "include",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({
//           mode: "download", // ★ PHP 側で実装する想定
//           token: token,
//           email: data.from_datetime || "",
//           name01: data.to_datetime || "",
//         }),
//       });

//       if (!response.ok) {
//         throw new Error(response.status);
//       }

//       const resData = await response.json();
//       console.log(resData);
      
//     } catch (err) {
//       if(err.message === "401" || err.message === "404"){
//         navigate("/login");
//       }
//       console.log(err);
//       setError("通信エラーです。");

//     } finally {
//       setSearching(false);
//     }
//   }

    const csvDownload = async (data) => {
  setSearching(true);
  setError(null);

  try {
    const response = await fetch(api_url, {
      method: "POST",
      mode: "cors",
      credentials: "include",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        mode: "download",
        token: token,
        email: data.from_datetime || "",
        name01: data.to_datetime || "",
      }),
    });

    if (!response.ok) {
      throw new Error(response.status);
    }

    const resData = await response.json();
    const rows = resData.data;

    if (!rows || rows.length === 0) {
      setError("対象データがありません。");
      return;
    }

    // CSVに出したい項目（順番もここで決める）
    const headers = [
      //"id",
      "user_id",
      "movie_id",
      "movie_title",
      "video_uri",
      "answer",
      "created_at",
    ];

    // CSV用に値をエスケープ（ダブルクォート・改行など）
    const escapeCell = (value) => {
      if (value === null || value === undefined) return "";
      const s = String(value).replace(/"/g, '""'); // " → ""
      // ダブルクォートで囲めば改行・カンマもOK
      return `"${s}"`;
    };

    //const headerLine = headers.join(",");
    const headerLine = 'ユーザーID,動画ID,動画タイトル,動画URL,回答,回答日時';
    const bodyLines = rows.map((row) =>
      headers
        .map((key) => escapeCell(row[key]))
        .join(",")
    );
    const csvString = [headerLine, ...bodyLines].join("\r\n");

    // Excel対策で BOM を付ける
    const bom = new Uint8Array([0xef, 0xbb, 0xbf]);
    const blob = new Blob([bom, csvString], {
      type: "text/csv;charset=utf-8;",
    });

    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;

    // ファイル名はお好みで
    const now = new Date();
    const yyyy = now.getFullYear();
    const mm = String(now.getMonth() + 1).padStart(2, "0");
    const dd = String(now.getDate()).padStart(2, "0");
    a.download = `movie_rating_${yyyy}${mm}${dd}.csv`;

    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);
  } catch (err) {
    if (err.message === "401" || err.message === "404") {
      navigate("/login");
      return;
    }
    console.error(err);
    setError("通信エラーです。");
  } finally {
    setSearching(false);
  }
};

  return (
    <div className="announcement-page">
      <div className="sub_title">動画アンケート結果ダウンロード</div>

      {/* 検索フォーム */}
      <div className="announcement-form-wrapper">
        <form className="frm ann-form-card" onSubmit={handleSubmit(csvDownload)}>
          <h4 className="announcement-title">日時指定</h4>

          <div className="frm-row">
            <label>開始日時</label>
            <input
              type="datetime-local"
              className="frm-input"
              {...register("from_datetime", {
                required: false,
              })}
            />
            <label>終了日時</label>
            <input
              type="datetime-local"
              className="frm-input"
              {...register("to_datetime", {
                required: false,
              })}
            />
            
          </div>
          
          <div className="frm-footer">
            <button
              type="submit"
              className="btn btn-primary"
              disabled={searching}
            >
              {searching ? "処理中..." : "ダウンロード"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default MovieRating;
